export const emailRegex = /^(?!\.)(?!.*\.\.)[A-Z0-9_'+\-.]*[A-Z0-9_+-]@(?:[A-Z0-9][A-Z0-9-]*\.)+[A-Z]{2,}$/iu;

/**
 * For use in <input pattern=...>
 * Browsers implicitly use the "v" flag and are always case-sensitive (no "i" flag).
 */
export const emailPattern =
	"(?!\\.)(?!.*\\.\\.)(?:[A-Za-z0-9_'+\\-.]*)[A-Za-z0-9_+\\-]@(?:[A-Za-z0-9][A-Za-z0-9\\-]*\\.)+[A-Za-z]{2,}";
